<template>
	<div class="imgText">
		<div class="newsDetail">
		    <header>
		        <h1>{{data.caption}}</h1>
		        <p>{{data.date}}</p>
		    </header>
		    <div class="newsInfo" v-html="data.content">
		        <p>中央美术学院美术馆原为中央美术学院陈列馆，建立于50年代初期，位于王府井大街中央美术学院旧址。</p>
		        <p>2003年4月3日，由日本著名建筑师矶崎新先生主持设计的中央美术学院新美术馆正式破土动工，美术馆座落于中央美院校园内，已建成中国最现代化的美术展览馆。</p>
		        <p>美术馆建筑呈微微扭转的三维曲面体美术馆建筑呈微微扭转的三维曲面体美术馆建筑呈微微扭转的三维曲面体美术馆建筑呈微微扭转的三维曲面体美术馆建筑呈微微扭转的三维曲面体</p>
		    </div>
		</div>
	</div>
</template>
<script type="text/javascript">
	export default {
		data(){
			return{
				data:'',
				id:''
			}
		},
		mounted(){
			this.id=this.$route.query.id;
			this.getData();
		},
		methods:{
			getData(){
				this.$http.get(this.$api+'/show_news_api.html?id='+this.id)
				.then(res => {
					this.data=res.data.data;
					//console.log(res)
				})
			},
		}
	}
</script>
<style scoped>
	.newsDetail{padding:0 .9rem;}
	.newsDetail header{border-bottom: 1px solid #444;padding-bottom: .35rem;padding-top: .75rem;margin-bottom: 1.25rem;}
	.newsDetail h1{font-size: .9rem;line-height: 1.35rem;color:#222;}
	.newsDetail header p{font-size: .55rem;color:#999;margin-top: .35rem;}
	.newsInfo{font-size: .7rem;line-height: 1.2rem;color:#444;}
	>>>.newsInfo p{margin-bottom: 1.2rem;text-align: justify!important;}
	>>>img{width: 100%!important;height:100%!important;}
</style>